export default __webpack_public_path__ + "static/media/FurnitureItem6.6560d177.png";